/*global anime */

import { Modal } from 'react-bootstrap';
import { useLayoutEffect, useState, useRef } from 'react'
import useModal from '#Context/Modal'
import columnResume from './Mikes_Resume(Column).png'

export default function MobileResume() {
    const { setModalProps } = useModal();
    const [width, setWidth] = useState(800)
    const modalBodyElement = useRef(null)

    useLayoutEffect(() => {
        modalBodyElement.current = document.querySelector('.modal-body');
        setResumeWidth();
        window.addEventListener('resize', setResumeWidth);
        return () => {
            window.removeEventListener('resize', setResumeWidth);
        }
    }, [])

    return (
        <>
            <Modal.Body ref={modalBodyElement} className='d-flex justify-content-center p-0' style={{ borderRadius: '30px' }}>
                {/*PDF viewing is sketchy on mobile devices, instead made it a png, option to download default pdf file */}
                <img className="" src={columnResume} width={width} style={{ height: 'max-content' }} alt="Patrick Mikes' Résumé"></img>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
                <a className="btn btn-lg text-light" style={{ backgroundColor: 'var(--dark)', border: '2px solid var(--spark)' }} download={true} href='/Mikes_Resume.pdf' >Save</a>
                <div className="mx-2">
                    <button className="btn btn-lg text-light d-block mb-2" style={{ backgroundColor: 'var(--dark)', border: '2px solid var(--spark)' }} updown={1} onClick={scroll}><i className="fa fa-angle-double-up"></i></button>
                    <button className="btn btn-lg text-light d-block" style={{ backgroundColor: 'var(--dark)', border: '2px solid var(--spark)' }} updown={0} onClick={scroll}><i className="fa fa-angle-double-down"></i></button>
                </div>
                <button className="btn btn-lg text-light" style={{ backgroundColor: 'var(--dark)', border: '2px solid var(--spark)' }} onClick={close}>Close</button>
            </Modal.Footer>
        </>
    )

    function close() {
        setModalProps({
            showing: false,
        })
    }

    function setResumeWidth() {
        console.log('resume resizer')
        let d = modalBodyElement.current.getBoundingClientRect();
        setWidth(Math.min(1000, d.width));
    }

    function scroll(e) {
        let up = e.currentTarget.getAttribute('updown') === '1' 
        let down = e.currentTarget.getAttribute('updown') === '0'
        anime({
            targets: modalBodyElement.current,
            scrollTop: {
                value: up ? `-=250` :`+=250`
            },
            easing: 'easeOutQuart'
        })
    }

}